<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="none">
    <path class="icon" :class="{ 'icon_filled': fill }" d="M5.085 17.303c-.547.288-.946.218-1.166.058-.219-.159-.409-.517-.304-1.126l.543-3.166c.08-.472.004-1.015-.152-1.496-.157-.48-.414-.966-.757-1.3l-2.3-2.242c-.442-.431-.5-.833-.416-1.09.084-.258.366-.55.977-.638l3.18-.462c.473-.07.966-.31 1.375-.607.409-.297.79-.692 1.003-1.121l1.421-2.88C8.763.677 9.127.5 9.398.5c.27 0 .635.178.909.732l1.421 2.88c.212.43.594.825 1.002 1.122.41.297.903.538 1.377.607l3.178.462c.612.088.894.38.977.637.084.258.028.66-.415 1.091l-2.3 2.242c-.343.334-.6.82-.757 1.3-.156.48-.233 1.024-.152 1.496l.543 3.166c.105.609-.085.967-.304 1.127-.22.159-.619.229-1.166-.059l-2.843-1.494c-.424-.223-.965-.318-1.47-.318s-1.046.095-1.47.318l-2.843 1.494z"/>
  </svg>
</template>

<script>
export default {
  props: {
    fill: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.icon {
  transition: $transition fill;
  stroke: $red-color3;
  fill: transparent;
  &_filled {
    fill: $red-color3;
  }
}
.currencies-table {
  .addFavorite {
    .icon {
      transition: none;
    }
  }
  .table__tr:hover {
    .addFavorite {
      .icon {
        stroke: $white-color2;
        fill: $red-color3;
          &_filled {
          fill: $white-color2;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/icons/IconStar.vue